import { PraxisConfigResponse } from "@shared/praxis-config";
import { config } from "../config/config";
import { getSubdomain } from "../utils/getSubdomain";

const praxisSubdomain = () => getSubdomain() ?? config.FALLBACK_SUBDOMAIN ?? "";

const praxisUrl = () =>
  `${config.LEAD_BACKEND_URL}/praxis/${encodeURIComponent(praxisSubdomain())}`;

export const praxisFaviconUrl = () => `${praxisUrl()}/favicon`;

export const loadPraxisConfig = async (): Promise<PraxisConfigResponse> => {
  const response = await fetch(`${praxisUrl()}/config`);

  if (!response.ok) {
    throw new Error(
      `Failed to load praxis config for "${praxisSubdomain()}": ${response.status}`,
    );
  }

  return response.json();
};
